module.exports = __webpack_public_path__ + "img/professioneel-logo-vr-games-at-home-nazareth-oculus-gaming-thuislevering-2.43d1a86e.jpg";